export default {
  title: "Design goals",
  note: "These suggested changes aim to improve diversity and give players additional ways to engage with the game. Some core design goals are listed below.",
  content: [
    {
      content: [
        "Diversity and variety! Expand on ways in which classes can be played, without changing them fundamentally.",
        "Focus on class design and some QoL. Leave content, professions and itemization to people with better ideas.",
        "Each spec should be great to have in a group, while none should be mandatory.",
        "Each spec, and each race/class combination should have its place in both PvE and PvP.",
        "Each spec gets something new. Some specs need more than others.",
        "Healers should be more independent and able to grind mobs and resources more easily.",
        "Adjust useless or boring talents and abilities.",
        "All while staying true to the classic fantasy and mechanics and leaning into the uniqueness of each class and spec.",
      ],
    },
  ],
};
